module.exports = __webpack_public_path__ + "media/images/hitfun/logo.hitfun-011c590886272c545554d97ce6b3ef66.svg";